import React from 'react';
import Progress from '../Progress';
import CardContainer from '../CardContainer';
import IconMoreActions from '../Icons/IconMoreActions';
import Avatar from '../Avatar';
import DropdownButton from '../DropdownButton';
import Wrapper from '../Wrapper';
import './ProgressCard.less';

export type ProgressCardProps = {
  avatarImage?: string;
  title?: string;
  progresses?: any;
  actions?: any;
};

const TProgressCard: React.FC<ProgressCardProps> = ({
  avatarImage,
  title,
  progresses = [],
  actions,
}) => {
  const progressColor = {
    attendance: '#3BE3C5',
    performance: '#9696FF',
  };

  return (
    <CardContainer background="white">
      <Wrapper mb={2}>
        <div className="t-progress-card-header">
          <Avatar boldText src={avatarImage} name={title} text={title} />
          {!!actions && (
            <DropdownButton
              icon={<IconMoreActions size="md" />}
              actions={actions}
            />
          )}
        </div>
      </Wrapper>
      {progresses.map((item, index) => {
        return (
          <Wrapper pt={2} key={index}>
            <Progress
              status="active"
              label={item.name}
              percent={item.percent}
              strokeColor={progressColor[item.type]}
            />
          </Wrapper>
        );
      })}
    </CardContainer>
  );
};

export default TProgressCard;
